import { IRapportInfo } from '../../../../../Types/RapportInfoType';
// import { rapportInfos } from '../RapportInfo';

const LRRapportMeny: IRapportInfo[] = [];

export default LRRapportMeny;
